import React, { useState } from 'react';
import { sendEmail } from '../services/emailService'; 

export default function ContactForm() {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    // Note que aqui não usamos ": any" ou ": string"
    const data = {
      to: "emerson.farias@esdevcode.com.br",
      subject: `Site Contato: ${formData.name} -  ${formData.subject}`,
      body: `Nome: ${formData.name}\nEmail: ${formData.email}\n\nMensagem: ${formData.message}`,
    };

    try {
      await sendEmail(data);
      setStatus({ type: 'success', message: 'E-mail enviado com sucesso!' });
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      setStatus({ type: 'error', message: error.message || 'Erro ao enviar' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form id="contact-form" onSubmit={onSubmit}>
      <div className="row gx-3 gy-4">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label">Nome</label>
            <input
              name="name"
              placeholder="Nome *"
              className="form-control"
              type="text"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              name="email"
              placeholder="Email *"
              className="form-control"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="form-label">Assunto</label>
            <input
              name="subject"
              placeholder="Assunto *"
              className="form-control"
              type="text"
              value={formData.subject}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="col-md-12">
          <div className="form-group">
            <label className="form-label">Mensagem</label>
            <textarea
              name="message"
              placeholder="Sua mensagem *"
              rows={4}
              className="form-control"
              value={formData.message}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="col-md-12">
          {status && (
            <div style={{ 
              padding: '10px', 
              marginBottom: '10px', 
              borderRadius: '4px',
              backgroundColor: status.type === 'success' ? '#d4edda' : '#f8d7da',
              color: status.type === 'success' ? '#155724' : '#721c24'
            }}>
              {status.message}
            </div>
          )}
          <div className="send">
            <button
              className={`btn btn-primary w-100 ${loading ? 'disabled' : ''}`}
              type="submit"
              disabled={loading}
            >
              {loading ? 'Enviando...' : 'Enviar Mensagem'}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}